import { useQuery } from "@tanstack/react-query";
import { createRelease } from "../api/real-cookie-banner.js";
import { useStores } from "../store/root.js";
import { QueryKeys } from "../util/query-keys.js";
function useReleaseCreate(customRef, requestedIds, disablePreReleaseClients) {
    const { rcbAuthenticationStore } = useStores();
    const releaseQuery = useQuery(QueryKeys.createRelease(customRef), ({ signal })=>{
        return createRelease({
            signal,
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            body: {
                ...requestedIds,
                disablePreReleaseClients
            }
        });
    }, {
        enabled: !!customRef,
        retry: false
    });
    return releaseQuery;
}
export { useReleaseCreate };
